import logo from '../../assets/img/logo-elecciones-colombia.png';
import logomex from '../../assets/img/logo-elecciones-mexico_horizontal.png';
import './PresiResume.scss';

const PresiResume = ({ votes, country }) => {
  const srcLogo = country === 'mex' ? logomex : logo;
  return (
    <div>
      <section className="p-resume">
        <div className="p-resume__logo">
          <img className="p-resume__logo-img" src={srcLogo} alt="Elecciones colombia" />
        </div>

        <div className="p-resume__desktop-separator"></div>
        <div className="p-resume__votes">
          <div className="p-resume__votes-top">
            <div className="p-resume__votes-data">
              VOTOS TOTALES <span> {votes.votesTotal} </span>
            </div>
          </div>
          <div className="p-resume__separator"></div>
          <div className="p-resume__votes-bot">
            <div className="p-resume__votes-data">
              VOTOS NULOS <span> {votes.votesAnnulled} </span>
            </div>
            <div className="p-resume__votes-separator"></div>
            <div className="p-resume__votes-data">
              VOTOS EN BLANCO <span> {votes.votesBlank} </span>
            </div>
            <div className="p-resume__votes-separator"></div>
            <div className="p-resume__votes-data">
              MESAS ESCRUTADAS <span> {votes.votesInvalid}% </span>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PresiResume;
